import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Form, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
  @Input() filterData: any;
  @Input() defaultFilters: any = {};
  @Input() selectedFilters: any = {};
  @Input() selectedFilterChips: any = [];
  @Output() filterSelectEvent = new EventEmitter<any>();
  @ViewChild('filterForm', { static: false }) filterForm: NgForm;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
  }


  filterSelected(category: string, filter: any) {
    filter.isSelected = !filter.isSelected;
    if (filter.isSelected) {
      this.selectedFilterChips.push({id:filter.filterId,value:filter.filterValue,type:category})
      if (!this.selectedFilters.hasOwnProperty(category)) {
        this.selectedFilters[category] = [];
        this.selectedFilters[category].push(filter.filterId);
      } else {
        this.selectedFilters[category].push(filter.filterId);
      }
    } else {
      this.selectedFilterChips.splice(this.selectedFilterChips.findIndex((item:any)=>item.type==category && item.value==filter.filterValue),1)
      this.selectedFilters[category].splice(
        this.selectedFilters[category].indexOf(filter.filterId),
        1
      );
      if (this.selectedFilters[category].length == 0) {
        delete this.selectedFilters[category];
      }
    }
    sessionStorage.setItem('filter_chips',JSON.stringify(this.selectedFilterChips))
    this.filterSelectEvent.emit({filters:this.selectedFilters,chips:this.selectedFilterChips,default:this.defaultFilters})
  }
}


